import React, { Component } from 'react';
import Header from './components/Header'
import KeyFeatures from './components/KeyFeatures'
import WalletGroup from './components/WalletGroup'
import './style.css'
import { header, lastPart, contentsWallet, contentsIntegrate, collabIntegrate, keyFeature } from './components/data'

import Simplify from './components/Simplify';
class BusinessOwners extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Header content={header.businessOwner}  />

        <WalletGroup contents={[contentsWallet.businessOwner, contentsIntegrate.businessOwner, collabIntegrate.businessOwner]} />

        <KeyFeatures data={keyFeature.businessOwner} />

        <Simplify content={lastPart.businessOwner} />
      </div>
    );
  };
}

export default BusinessOwners;
